export const getDisplayBrand = (brand?: string): string => {
  if (!brand) return "Genérico";
  return brand.toLowerCase() !== "none" ? brand : "Genérico";
};
